import { Components, Theme } from '@mui/material';

export const linearProgressStyles: Components<Theme>['MuiLinearProgress'] = {
  styleOverrides: {
    root: ({ theme }) => ({
      height: 8,
      backgroundColor: theme.palette.customGrey.light
    }),
    bar: ({ theme }) => ({
      backgroundColor: theme.palette.customGrey.dark
    })
  }
};
